import { apiGet } from '@/api/client';
import type { ReportExport, ReportKey, ReportSummary } from '@/api/types';

export function listReports(companyId: string): Promise<ReportSummary[]> {
  return apiGet('/companies/{companyId}/reports', {
    params: { companyId },
  }) as unknown as Promise<ReportSummary[]>;
}

/**
 * Exports one report. `format` defaults to `csv`; `pdf` is accepted but the
 * API always returns CSV content plus a `note` explaining PDF rendering
 * isn't implemented (PLAN-FASE3.md WP-04 open point) — the caller decides
 * what to do with that note (see `ReportsPage.tsx`'s `exportReport`).
 */
export function exportReport(
  companyId: string,
  reportKey: ReportKey,
  format: 'csv' | 'pdf' = 'csv',
): Promise<ReportExport> {
  return apiGet('/companies/{companyId}/reports/{reportKey}/export', {
    params: { companyId, reportKey },
    query: { format },
  }) as unknown as Promise<ReportExport>;
}
